// FormContext.jsx (or FormContext.js)
import { createContext, useContext } from 'react'

const FormContext = createContext(null)

export const FormProvider = FormContext.Provider

export const useFormContext = () => {
  const context = useContext(FormContext)
  if (!context) {
    throw new Error('useFormContext must be used within FormProvider')
  }
  return context
}